<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="400"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold mb-2">
                <v-icon left>
                  mdi-view-dashboard
                </v-icon>
                Tableau de bord Happy Quest
                <v-icon right>
                  mdi-view-dashboard
                </v-icon>
              </h1>
            </div>
          </template>

          <v-card-text class="text-center">
            <div class="text-center grey--text body-1 font-weight-bold">
              Mot de passe oublié ?
            </div>

            <!-- Formulaire -->
            <v-form
              v-if="!displaySuccess && !isLoading"
              v-model="isValid"
            >
              <v-text-field
                v-model="email"
                color="secondary"
                label="Email..."
                :rules="[rules.required, rules.email]"
                hide-details="auto"
                hint="example@happyquest.fr"
                prepend-icon="mdi-at"
                required
              />

              <p
                v-if="error.hasError"
                class="title text-uppercase error--text"
              >
                {{ error.errorMsg }}
              </p>

              <div class="my-2">
                <v-btn
                  class="ma-2"
                  outlined
                  color="primary"
                  :disabled="!isValid"
                  @click="handleFormSubmit"
                >
                  Récupérer mon mot de passe
                  <v-icon right>
                    mdi-chevron-right
                  </v-icon>
                </v-btn>
              </div>
            </v-form>
            <!-- Affichage du chargement -->
            <v-row
              v-else
              justify="center"
            >
              <circle10 />
            </v-row>

            <v-btn
              class="ma-2"
              text
              color="primary"
              @click="handleLogin"
            >
              Se connecter
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  /* Les composants et packages dont on a besoin */
  import { Circle10 } from 'vue-loading-spinner'

  /* Rend le composant accessible aux autres composants */
  export default {
    /* Nom du composant */
    name: 'ForgottenPassword',

    /* Sous-composants utilisés par ce composant */
    components: {
      Circle10,
    },

    /* Variables internes
     * data doit être une fonction si ce composant est utilisé dans un autre composant */
    data: function () {
      return {
        email: '',
        displaySuccess: false,
        isLoading: false,
        isValid: false,
        error: {
          hasError: false,
          errorMsg: '',
        },
        rules: {
          required: value => !!value || 'Ce champ ne peut être vide.',
          email: value => {
            const pattern = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i
            return pattern.test(value) || 'Email invalide.'
          },
        },
      }
    },

    /* Fonctions internes */
    methods: {
      // Récupération du mot de passe par mail
      handleFormSubmit: function (e) {
        e.preventDefault()
        this.isLoading = true
        this.$Auth.httpRequest('get', 'passwordForgotten/' + this.email)
          .then(res => {
            this.$router.push({
              name: 'Login',
              params: {
                displaySnackMsg: true,
                snackMsg: 'Tu peux surveiller tes mails, tu vas en recevoir un !',
              },
            })
          })
          .catch(err => {
            this.error.hasError = true
            this.error.errorMsg = err.response.data
          }).finally(() => {
            this.isLoading = false
          })
      },

      // Route vers la page de connection
      handleLogin: function () {
        this.$router.push({ name: 'Login' })
      },
    },
  }
</script>
